import React from 'react';

const Payment = () => {
    return (
        <div>
            <h3>Payment system is comming soon</h3>
        </div>
    );
};

export default Payment;